import { render } from "./InputTypeFile.vue?vue&type=template&id=dd3f0480"
import script from "./InputTypeFile.vue?vue&type=script&lang=js"
export * from "./InputTypeFile.vue?vue&type=script&lang=js"

import "./InputTypeFile.vue?vue&type=style&index=0&id=dd3f0480&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__